import { render, staticRenderFns } from "./BlockDataSidebar.vue?vue&type=template&id=05b4dda5&scoped=true&"
import script from "./BlockDataSidebar.vue?vue&type=script&lang=js&"
export * from "./BlockDataSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BlockDataSidebar.vue?vue&type=style&index=0&id=05b4dda5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4dda5",
  null
  
)

export default component.exports